<template>
  
  <div class="main-login">
   
   <!--- medium and large screen -->
  <b-row class="main-row">
    <show-at :breakpoints="{small: 600, medium: 601, large: 1050}" breakpoint="mediumAndAbove">
    <b-col cols="lg-8 sm-12" style="background-color:#FFF">
      <img src="img/login_main.jpg" class="img-fluid ">
      <b-row>
          <b-col class="md-5 sm-12 p-3 pr-5" offset="1">
            <h2 class="typo-display-medium">IL POSTO GIUSTO PER I TUOI IMPIANTI</h2>
            <p class="typo-subtit">
              NuBe è la piattaforma cloud di accesso e gestione di tutti gli impianti Beghelli in grado di gestire sia l’illuminazione che l’illuminazione di emergenza. 
           </p>
          </b-col>
          <b-col class="lg-3 sm-12 p-3 pr-5">
            <h2 class="typo-display-medium">UNA DASHBOARD SMART E INTUITIVA</h2>
            <p class="typo-subtit">
              Monitora lo stato dell’impianto in tempo reale: l'attuale configurazione, eventuali failure e l'esito dei test diagnostici.
            </p>
          </b-col>
      </b-row>    
      <b-row>
          <b-col class="md-5 sm-12 p-3 pr-5" offset="1">
            <h2 class="typo-display-medium">
               <img src="img/Bconnect.png" class="img-fluid" style="width:7%">
              SCARICA L'APP BCONNECT</h2>
            <p class="typo-subtit">
              B.Connect è l'app univoca per la gestione di tutti i sistemi di controllo degli apparecchi autoalimentati Beghelli.
              Consente di  accedere direttamente all’apparecchio, alla Centrale oppure alla piattaforma cloud NuBe.
           </p>
          </b-col>
          <b-col class="lg-3 sm-12 p-3 pr-5">
            <h2 class="typo-display-medium">FUNZIONALITA' AVANZATE CON NUBE PRO</h2>
            <p class="typo-subtit">
              Eseguendo l’upgrade alla versione NuBe PRO è possibile gestire impianti multisistema e accedere a servizi evoluti come l’inserimento degli apparecchi su foto ambienti
              / planimetrie oppure consultare lo storico dei LogBook.
            </p>
          </b-col>
      </b-row>   

    </b-col>
    </show-at>


   <b-col class="aside-form lg-2 md-3 sm-8">
     <div class="justify-content-center m-4">
      <b-form class="justify-content-center img-fluid mt-5">
                  <div class="d-flex justify-content-center mb-4">
                    <img class="justify-content-center img-fluid" src="/img/logo_new.png">
                  </div>

                  <!-- login email -->
                  <b-form-group>
                    <label for="login-email">{{this.$t("signup.emailAddress")}}</label>
                    <b-form-input v-model="email" type="text" class="form-control typo-input"/>
                  </b-form-group>

                  <!-- login password -->
                  <b-form-group>
                    <label class="float-left">{{this.$t("signup.password")}}</label>
                    <b-button  @click="gotoPasswordDimenticata" variant="link" class="float-right typo-linkgrey">{{$t("signup.forgotpassword")}}</b-button>
                    <b-form-input v-model="password" type="password" class="form-control typo-input"/>
                  </b-form-group>

                  <!-- Alert da utilizzare in caso utente non riconosciuto alla login -->
                  <b-row class="mt-2 justify-content-center">
                    <b-alert
                      :show="dismissCountDown"
                      dismissible
                      variant="danger"
                      @dismissed="dismissCountDown=0"
                      @dismiss-count-down="countDownChanged">
                    <p>{{ alertMessage }}</p>
                    </b-alert>
                  </b-row>  

                  <!-- Accedi -->
                  <div class="d-flex justify-content-center mb-3">
                    <b-button pill @click="accediClicked" variant="primary" class="px-5 mt-3 but-pill"><span class="text-pill">{{$t("signup.accedi")}}</span></b-button>
                  </div>
                  <!-- Registrazione -->
                  <div class="d-flex justify-content-center">
                    <label class="typo-black">{{this.$t("signup.notSignup")}}</label>
                    <b-button @click="gotoRegistrati" variant="link" class="typo-linkblue ml-2">{{this.$t("signup.nowSignup")}}</b-button>
                  </div>
        </b-form>
     </div>  
  </b-col>

  </b-row> 
    
  </div>


</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
  name: 'LoginNew',
  components: {
    hideAt, showAt
  },
  props: [],
  data() {
      return {
          email: '',
          password: '',
          signedIn: false,
          currUser: null,
          accedi:false,
          dismissSecs: 5,
          dismissCountDown: 0,
          alertMessage:""

      }
  },
  methods: {
    
    gotoRegistrati() {
      this.$router.push('/registrati');
    },
    gotoPasswordDimenticata(
    ) {
      this.$router.push('/passworddimenticata');
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
      },
    accediClicked() {
      console.log("cliccato accedi!");
      this.accedi=true;
      this.$store.state.user = {};
      this.$store.state.userAllPlants = null;
      Auth.signIn(this.email,this.password)
      .then(user => {

        console.log(user);

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$store.state.user=user;
          this.$router.push('/setpassword');
        } else {
          this.$store.commit('setLoggedUser',user);
          this.signedIn = true;
          this.$store.state.loading = true;
          this.$router.push('/');
        }
      })
      .catch(err => {console.log("login error", err);
        if (err.code == "UserNotConfirmedException") {
          this.completeReg = true;
          return;
        }

        this.alertMessage=this.$t("signup.errorAut");
        this.showAlert();
      });
    }
  },
  beforeCreate() {
      AmplifyEventBus.$on('authState', info => {
        console.log("authState:",info)
        if (info === 'signedIn') {
            this.signedIn = true
            this.$router.push('/')
        }
      });

      Auth.currentAuthenticatedUser().then(user => {

          this.signedIn = true
      }).catch(() => this.signedIn = false)
  }
}
</script>

<style scoped>

@media screen and (max-width: 767px) {
  .loginPage {
    height: 100%;
    margin-top: 0px;
}

  .loginPanel {
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 20%;
    padding-top: 10px;
    border-radius: 10px;
  }

  .pwdButton {
    color: #000000;
    font-size: 16px;
  }

}

.auth {
  margin: 0 auto;
  width: 460px;
}
</style>